export const GET_DATA_REQUEST="GETDATA_REQUEST";
export const GET_DATA_SUCCESS="GETDATA_SUCCESS";
export const GET_DATA_FAILURE="GETDATA_FAILURE";